import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Loader from "../../../../Common/Loader/loader";
import { TonnageCompositionFilter } from "./TonnageCompositionFilter";
import isGHMC, { formatDateTimeWithoutSec, formattedDate, getCurrentDateTime } from "../../../../Common/helper/helpar";
import TonnageCompositionStore from "./store/TonnageCompositionStore";

const TonnageCompositionReport = () => {
  const { tonnageCompositionReportData, loading } =
    TonnageCompositionStore();

  const isProd = isGHMC();

  const currentDateTime = getCurrentDateTime();
  /* ================= STYLES ================= */

  const headerStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "10px",
    color: "#fff",
    backgroundColor: isProd ? "#0d5da5" : "#EC1117",
    fontWeight: 600,
  };

  const cellStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "10px",
    whiteSpace: "normal",
  };

  /* ================= TOTALS ================= */

  const totalSatTrips = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item["SAT Trips"]) || 0),
    0
  );

  const totalSecondary = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item.Secondary) || 0),
    0
  );

  const totalOthers = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item.Others) || 0),
    0
  );

  const totalEstimatedMT = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item["Estimated Tonnage"]) || 0),
    0
  );

  const totalHKL = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item.HKL) || 0),
    0
  );

  const totalRCV = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item.RCV) || 0),
    0
  );

  const totalPVT = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item["PVT Veh"]) || 0),
    0
  );

  const totalEstTonnage = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item.EstimatedWeight) || 0),
    0
  );

  const totalActualMT = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item.Actual) || 0),
    0
  );

  const totalVariance = tonnageCompositionReportData.reduce(
    (sum, item) => sum + (Number(item.Variance) || 0),
    0
  );

  /* ================= DATE FORMAT ================= */

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.split("T")[0]; // yyyy-mm-dd
  };

  /* ================= UI ================= */

  const storedFilters = localStorage.getItem("tonnageCompositionFilters");
  const parsedFilters = storedFilters ? JSON.parse(storedFilters) : {};


  return (
    <>
      {loading && <Loader />}

      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">

            <TonnageCompositionFilter data={tonnageCompositionReportData}/>

            <div className="page-header text-start">
              <div className="card">
                <div className="card-body">

                  <div className="top-header text-center" style={{ width: "100%" }}>
                    {/* <div className="mb-2 fw-bold" style={{ textAlign: "center" }}>
                      Tonnage Composition Report Generated on: {formatDateTimeWithoutSec(currentDate)}
                    </div> */}
                    <span style={{ textAlign: "center" }}>
                      Tonnage Composition Report as on {parsedFilters?.FromDate && parsedFilters?.ToDate
                        ? `(${formattedDate(parsedFilters.FromDate)} to ${formattedDate(parsedFilters.ToDate)})`
                        : "—"} at ({formatDateTimeWithoutSec(currentDateTime)})
                    </span>
                  </div>

                  <TableContainer
                    component={Paper}
                    sx={{
                      width: "100%",
                      border: "1px solid #ccc",
                      maxHeight: 700,
                    }}
                  >
                    <Table stickyHeader>

                      {/* ================= HEADER ================= */}

                      <TableHead>
                        <TableRow>
                          <TableCell rowSpan={2} sx={headerStyles}>
                            S.No
                          </TableCell>

                          <TableCell style={{minWidth: 100}} rowSpan={2} sx={headerStyles}>
                            Date
                          </TableCell>
                          <TableCell rowSpan={2} sx={headerStyles}>
                            TS/SCTP
                          </TableCell>
                          <TableCell sx={headerStyles}>SAT Trips</TableCell>
                          <TableCell sx={headerStyles}>Secondary</TableCell>
                          <TableCell sx={headerStyles}>Others</TableCell>
                          <TableCell sx={headerStyles}>
                            Estimated Tonnage
                          </TableCell>

                          <TableCell sx={headerStyles}>HKL</TableCell>
                          <TableCell sx={headerStyles}>RCV</TableCell>
                          <TableCell sx={headerStyles}>PVT</TableCell>
                          <TableCell sx={headerStyles}>Est MT</TableCell>

                          <TableCell rowSpan={2} sx={headerStyles}>
                            Actual MT
                          </TableCell>

                          <TableCell rowSpan={2} sx={headerStyles}>
                            Variance
                          </TableCell>
                        </TableRow>

                        <TableRow>
                        </TableRow>
                      </TableHead>

                      {/* ================= BODY ================= */}

                      <TableBody>
                        {tonnageCompositionReportData?.length > 0 ? (
                          <>
                            {tonnageCompositionReportData.map(
                              (item, index) => (
                                <TableRow
                                  key={index}
                                  sx={{
                                    backgroundColor: isProd
                                      ? index % 2 === 0
                                        ? "#8fc9ff"
                                        : "#aed8ff"
                                      : index % 2 === 0
                                        ? "#F8CCCD"
                                        : "#ffeded",
                                  }}
                                >
                                  <TableCell sx={cellStyles}>
                                    {index + 1}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {formattedDate(item.Date)}
                                  </TableCell>
                                  <TableCell sx={cellStyles}>
                                    {item.TransferStationName}
                                  </TableCell>
                                  <TableCell sx={cellStyles}>
                                    {item["SAT Trips"]}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item.Secondary}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item.Others}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item["Estimated Tonnage"]}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item.HKL}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item.RCV}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item["PVT Veh"]}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item.EstimatedWeight}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item.Actual}
                                  </TableCell>

                                  <TableCell sx={cellStyles}>
                                    {item.Variance}
                                  </TableCell>
                                </TableRow>
                              )
                            )}

                            {/* ================= TOTAL ROW ================= */}

                            <TableRow
                              sx={{
                                backgroundColor: isProd
                                  ? "#0d5da5"
                                  : "#EC1117",
                                "& .MuiTableCell-root": {
                                  color: "#fff",
                                  fontWeight: 700,
                                },
                              }}
                            >
                              <TableCell sx={cellStyles}></TableCell>

                              <TableCell sx={cellStyles}>
                                Total
                              </TableCell>
                              <TableCell sx={cellStyles}>
                                {/* {totalSatTrips} */}
                              </TableCell>
                              <TableCell sx={cellStyles}>
                                {totalSatTrips}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalSecondary}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalOthers}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalEstimatedMT}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalHKL}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalRCV}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalPVT}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalEstTonnage}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalActualMT}
                              </TableCell>

                              <TableCell sx={cellStyles}>
                                {totalVariance}
                              </TableCell>
                            </TableRow>
                          </>
                        ) : (
                          <TableRow>
                            <TableCell
                              sx={cellStyles}
                              colSpan={12}
                            >
                              No Data Available
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default TonnageCompositionReport;
